import * as React from 'react';
import { Button } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import UserAvatar from "../UserAvatar";
import { useAuth } from "../../../services/auth";
import { colors } from "../../../theme";

export default function ProfileButton() {
    const navigate = useNavigate();
    const { logout, username, profilePictureUrl } = useAuth();

    const handleLogout = (close: () => void) => {
        close();
        logout();
        navigate('/');
    };

    return (
        <PopupState variant="popover" popupId="shufl-profile-menu">
            {(popupState) => (
                <React.Fragment>
                    <Button
                        {...bindTrigger(popupState)}
                        aria-label="Account menu"
                        sx={{
                            p: 0,
                            minWidth: 0,
                            width: 38,
                            height: 38,
                            borderRadius: "50%",
                            backgroundColor: colors.elevatedHover,
                            border: `1px solid ${colors.line}`,
                            "&:hover": {
                                backgroundColor: "#2A3442",
                                transform: "scale(1.06)",
                            },
                        }}
                    >
                        <UserAvatar username={username} imageUrl={profilePictureUrl} size={32} />
                    </Button>
                    <Menu
                        {...bindMenu(popupState)}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    >
                        <MenuItem onClick={popupState.close}>Profile</MenuItem>
                        <MenuItem onClick={() => { popupState.close(); navigate('/dashboard/settings'); }}>
                            Settings
                        </MenuItem>
                        <MenuItem onClick={() => handleLogout(popupState.close)}>Log out</MenuItem>
                    </Menu>
                </React.Fragment>
            )}
        </PopupState>
    );
}
